import { EntityTemplateVariables } from '@tools/interfaces/template';
import { getContactFieldsForEntity } from './template-contact';

export const templateActivitySessionWaitingContact: EntityTemplateVariables = {
  fields: [],
  related: [
    {
      relationName: 'activitySession',
      relationType: 'simple',
      label: 'templates.attendees.activity_session.label',
      description: 'templates.attendees.activity_session.description',
      fields: [
        {
          label: 'templates.activity_sessions.code.label',
          contentValue: '{{ activity_session_waiting_contact.activitySession.code }}',
          description: 'templates.activity_sessions.code.description',
        },
        {
          label: 'templates.activity_sessions.name.label',
          contentValue: '{{ activity_session_waiting_contact.activitySession.name }}',
          description: 'templates.activity_sessions.name.description',
        },
        {
          label: 'templates.activity_sessions.start_date_time.label',
          contentValue:
            '{{ activity_session_waiting_contact.activitySession.start_date_time | date("d/m/Y H:i") }}',
          description: 'templates.activity_sessions.start_date_time.description',
        },
        {
          label: 'templates.activity_sessions.attendees_start_date_time.label',
          contentValue:
            '{{ activity_session_waiting_contact.activitySession.attendees_start_date_time | date("d/m/Y") }}',
          description: 'templates.activity_sessions.attendees_start_date_time.description',
        },
        {
          label: 'templates.activity_sessions.attendees_end_date_time.label',
          contentValue:
            '{{ activity_session_waiting_contact.activitySession.attendees_end_date_time | date("d/m/Y") }}',
          description: 'templates.activity_sessions.attendees_end_date_time.description',
        },
        {
          label: 'templates.activity_sessions.min_participants.label',
          contentValue: '{{ activity_session_waiting_contact.activitySession.min_participants }}',
          description: 'templates.activity_sessions.min_participants.description',
        },
        {
          label: 'templates.activity_sessions.max_participants.label',
          contentValue: '{{ activity_session_waiting_contact.activitySession.max_participants }}',
          description: 'templates.activity_sessions.max_participants.description',
        },
      ],
    },
    {
      relationName: 'contact',
      relationType: 'simple',
      label: 'templates.bookings.contact.label',
      description: 'templates.bookings.contact.description',
      fields: getContactFieldsForEntity('activity_session_waiting_contact.'),
    },
  ],
  relatedInLoop: [],
};
